<template>
  <div id="exchangeChart"></div>
</template>

<script>
import echarts from 'echarts'
import { getDMData } from "common/js/http/v3Api";
export default {
  data() {
    return {
      id: 'F03_01_02_02_C',
      pagesize: '421',
      clientHeight: '',
      code: null,
      other: null,
      forexData: [],
      chart: null,
      legendLabel1: '',
      legendLabel2: '',
      lineData: [],
      seriesData1: [],
      seriesData2: [],
      unit: ''
    }
  },
  watch: {
  },
  created() {
    this.code = this.$route.query.code
    this.getChartData()
  },
  methods: {
    async getChartData(row) {
      const { data } = await getDMData({
        'id': this.id,
        'code': this.code,
        'pagesize': this.pagesize,
        'begindate': this.begindate,
        'enddate': this.enddate,
        'other': row.CODE_ID
      });
      if (data != null && data.length !== 0) {
        this.lineData = data[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
        this.seriesData1 = data[0].bid1.split(',').map(item => item.replace(/\'/g, ''))
        this.seriesData2 = data[0].bond10_value.split(',').map(item => item.replace(/\'/g, ''))
        this.legendLabel1 = '汇率'
        this.legendLabel2 = '十年期政府债券收益率'
        this.initChart()
      }
    },
    initChart() {
      var option = {
        title: {
          textStyle: {
            color: '#4c5e70',
            fontSize: '16',
            fontWeight: 400
          }
        },
        color: ['#3fb1e3', '#cc70af', '#ffb980', '#9b8bba',
          '#e098c7', '#97b552', '#d87a80', '#eedd78',
          '#2ec7c9', '#626c91', '#cbb0e3', '#73a373', '#8dc1a9',
          '#97d4dc', '#82c0c9', '#b7dba1', '#a0a7e6', '#6be6c1'],
        grid: {
          x: 40,
          y: 80,
          x2: 55,
          y2: 40,
          containLabel: true
        },
        legend: {
          textStyle: {
            fontSize: 12,
            color: '#636363'
          },
          data: [{ name: this.legendLabel1, icon: 'rect' }, { name: this.legendLabel2, icon: 'rect' }],
          itemWidth: 17,
          itemHeight: 3,
          left: 5,
          top: 25
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#9ca0a9',
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: '0.5',
              type: 'dashed'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'line'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.lineData,
            axisTick: {
              show: true,
              lineStyle: {
                color: '#DFE1E5'
              }
            },
            axisLine: { show: false }
          }
        ],
        dataZoom: [
          {
            type: 'slider', // 图表下方的伸缩条
            show: true,  // 是否显示
            realtime: true,  //
            start: 80,  // 伸缩条开始位置（1-100），可以随时更改
            end: 100,  // 伸缩条结束位置（1-100），可以随时更改
            bottom: 17,
            height: 20
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            axisTick: {
              show: false
            },
            axisLine: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#dfe1e5']
              }
            }
          },
          {
            name: '%',
            type: 'value',
            scale: true,
            axisTick: {
              show: false
            },
            axisLine: { show: false },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: this.legendLabel1,
            type: 'line',
            areaStyle: { normal: {} },
            showSymbol: false,
            symbolSize: 0.5,
            symbol: 'circle',
            data: this.seriesData1
          },
          {
            name: this.legendLabel2,
            type: 'line',
            yAxisIndex: 1,
            areaStyle: { normal: {} },
            showSymbol: false,
            symbolSize: 0.5,
            symbol: 'circle',
            data: this.seriesData2
          }
        ]
      }
      this.chart = echarts.init(document.getElementById('exchangeChart'))
      this.chart.setOption(option)
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    }
  }
}
</script>

<style scoped>
#chart {
  width: 100%;
  height: 100%;
}
</style>
